import React from 'react'
import type { AlertHoverPayload } from './alertHover.types'

import {
  AgreementsBody,
  BirthdayBody,
  FirstSessionBody,
  FormsBody,
  IntroOffersBody,
  LocationBody,
  NotesPropertiesBody,
  PackagesBody,
  PaymentBody,
  SuspendedBody,
} from './bodies'

const BODY_COMPONENTS = {
  payment: PaymentBody,
  agreements: AgreementsBody,
  forms: FormsBody,
  notesProps: NotesPropertiesBody,
  location: LocationBody,
  birthday: BirthdayBody,
  firstSession: FirstSessionBody,
  introOffers: IntroOffersBody,
  packages: PackagesBody,
  suspended: SuspendedBody,
} as const

export const AlertHoverBodies: React.FC<{ data: AlertHoverPayload }> = ({ data }) => {
  const Component = BODY_COMPONENTS[data.type as keyof typeof BODY_COMPONENTS]
  if (!Component) return null
  // Type assertion needed because body type varies by alert type
  return <Component body={data.body as never} />
}
